<template>
  <el-card>
    <el-button type="primary" @click="handleSubmit" :disabled="!selectDatas.length">{{
      $t('sysConfig.submit')
    }}</el-button>
    <el-button type="primary" @click="getTableData">{{
      $t('channel.label.refresh')
    }}</el-button>
    <el-row style="margin: 10px 0">
      <el-table height="800" ref="chanelTable" border :data="tableData" :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ textAlign: 'center' }" stripe @selection-change="handleSelectionChange" :key="itemKey">
        <el-table-column type="selection" width="55" />
        <el-table-column prop="merchantId" :label="$t('channelList.label.merchantId')" />
       <el-table-column prop="merchantName" :label="$t('channelList.label.merchantName')" />
        <el-table-column prop="Mobifone" align="center" label="Mobifone">
          <template slot="header" slot-scope="scope">
            <el-checkbox v-model="checkAllObj.Mobifone" @change="(val) => handleCheckAll(scope.column.property, val)" />
            Mobifone
          </template>
          <template slot-scope="{ row }">
            <el-checkbox :checked="row['Mobifone'] > 0"
              @change="(val) => updateListObjDate(row.merchantId, 'Mobifone', val)" />
          </template>
        </el-table-column>
        <el-table-column prop="VietnamMobile" align="center" label="VietnamMobile">
          <template slot="header" slot-scope="scope">
            <el-checkbox v-model="checkAllObj.VietnamMobile"
              @change="(val) => handleCheckAll(scope.column.property, val)" />
            VietnamMobile
          </template>
          <template slot-scope="{ row }">
            <el-checkbox :checked="row['VietnamMobile'] > 0"
              @change="(val) => updateListObjDate(row.merchantId, 'VietnamMobile', val)" />
          </template>
        </el-table-column>
        <el-table-column prop="Viettel" align="center" label="Viettel">
          <template slot="header" slot-scope="scope">
            <el-checkbox v-model="checkAllObj.Viettel" @change="(val) => handleCheckAll(scope.column.property, val)" />
            Viettel
          </template>
          <template slot-scope="{ row }">
            <el-checkbox :checked="row['Viettel'] > 0"
              @change="(val) => updateListObjDate(row.merchantId, 'Viettel', val)" />
          </template>
        </el-table-column>
        <el-table-column prop="Vinaphone" align="center" label="Vinaphone">
          <template slot="header" slot-scope="scope">
            <el-checkbox v-model="checkAllObj.Vinaphone"
              @change="(val) => handleCheckAll(scope.column.property, val)" />
            Vinaphone
          </template>
          <template slot-scope="{ row }">
            <el-checkbox :checked="row['Vinaphone'] > 0"
              @change="(val) => updateListObjDate(row.merchantId, 'Vinaphone', val)" />
          </template>
        </el-table-column>
        <el-table-column prop="QR_SUN" align="center" label="QR_SUN">
          <template slot="header" slot-scope="scope">
            <el-checkbox v-model="checkAllObj.QRPRO" @change="(val) => handleCheckAll(scope.column.property, val)" />
            QR_SUN
          </template>
          <template slot-scope="{ row }">
            <el-checkbox :checked="row['QR_SUN'] > 0"
              @change="(val) => updateListObjDate(row.merchantId, 'QR_SUN', val)" />
          </template>
        </el-table-column>
        <el-table-column prop="bank_qr" align="center" label="bank_qr">
          <template slot="header" slot-scope="scope">
            <el-checkbox v-model="checkAllObj.bankQr" @change="(val) => handleCheckAll(scope.column.property, val)" />
            bank_qr
          </template>
          <template slot-scope="{ row }">
            <el-checkbox :checked="row['bank_qr'] > 0"
              @change="(val) => updateListObjDate(row.merchantId, 'bank_qr', val)" />
          </template>
        </el-table-column>
        <el-table-column prop="bank_transfer" align="center" label="bank_transfer">
          <template slot="header" slot-scope="scope">
            <el-checkbox v-model="checkAllObj.bankTransfer"
              @change="(val) => handleCheckAll(scope.column.property, val)" />
            bank_transfer
          </template>
          <template slot-scope="{ row }">
            <el-checkbox :checked="row['bank_transfer'] > 0"
              @change="(val) => updateListObjDate(row.merchantId, 'bank_transfer', val)" />
          </template>
        </el-table-column>
        <el-table-column prop="momo_qr" align="center" label="momo_qr">
          <template slot="header" slot-scope="scope">
            <el-checkbox v-model="checkAllObj.momoQr" @change="(val) => handleCheckAll(scope.column.property, val)" />
            momo_qr
          </template>
          <template slot-scope="{ row }">
            <el-checkbox :checked="row['momo_qr'] > 0"
              @change="(val) => updateListObjDate(row.merchantId, 'momo_qr', val)" />
          </template>
        </el-table-column>
        

        <el-table-column prop="viettel_fix_qr" align="center" label="viettel_fix_qr">
          <template slot="header" slot-scope="scope">
            <el-checkbox v-model="checkAllObj.viettelFixQr"
              @change="(val) => handleCheckAll(scope.column.property, val)" />
            viettel_fix_qr
          </template>
          <template slot-scope="{ row }">
            <el-checkbox :checked="row['viettel_fix_qr'] > 0"
              @change="(val) => updateListObjDate(row.merchantId, 'viettel_fix_qr', val)" />
          </template>
        </el-table-column>

        <el-table-column prop="viettel_qr" align="center" label="viettel_qr">
          <template slot="header" slot-scope="scope">
            <el-checkbox v-model="checkAllObj.viettelQr"
              @change="(val) => handleCheckAll(scope.column.property, val)" />
            viettel_qr
          </template>
          <template slot-scope="{ row }">
            <el-checkbox :checked="row['viettel_qr'] > 0"
              @change="(val) => updateListObjDate(row.merchantId, 'viettel_qr', val)" />
          </template>
        </el-table-column>
        <el-table-column prop="zalo_qr" align="center" label="zalo_qr">
          <template slot="header" slot-scope="scope">
            <el-checkbox v-model="checkAllObj.zaloQr" @change="(val) => handleCheckAll(scope.column.property, val)" />
            zalo_qr
          </template>
          <template slot-scope="{ row }">
            <el-checkbox :checked="row['zalo_qr'] > 0"
              @change="(val) => updateListObjDate(row.merchantId, 'zalo_qr', val)" />
          </template>
        </el-table-column>
        <el-table-column prop="payout" align="center" label="payout">
          <template slot="header" slot-scope="scope">
            <el-checkbox v-model="checkAllObj.payout" @change="(val) => handleCheckAll(scope.column.property, val)" />
            payout
          </template>
          <template slot-scope="{ row }">
            <el-checkbox :checked="row['payout'] > 0"
              @change="(val) => updateListObjDate(row.merchantId, 'payout', val)" />
          </template>
        </el-table-column>
        <el-table-column prop="momo_bank" align="center" label="momo_bank">
          <template slot="header" slot-scope="scope">
            <el-checkbox v-model="checkAllObj.momo_bank" @change="(val) => handleCheckAll(scope.column.property, val)" />
              momo_bank
          </template>
          <template slot-scope="{ row }">
            <el-checkbox :checked="row['momo_bank'] > 0"
              @change="(val) => updateListObjDate(row.merchantId, 'momo_bank', val)" />
          </template>
        </el-table-column>
        <el-table-column prop="zalo_bank" align="center" label="zalo_bank">
          <template slot="header" slot-scope="scope">
            <el-checkbox v-model="checkAllObj.zalo_bank" @change="(val) => handleCheckAll(scope.column.property, val)" />
              zalo_bank
          </template>
          <template slot-scope="{ row }">
            <el-checkbox :checked="row['zalo_bank'] > 0"
              @change="(val) => updateListObjDate(row.merchantId, 'zalo_bank', val)" />
          </template>
        </el-table-column>
        <el-table-column prop="vtpay_bank" align="center" label="vtpay_bank">
          <template slot="header" slot-scope="scope">
            <el-checkbox v-model="checkAllObj.vtpay_bank" @change="(val) => handleCheckAll(scope.column.property, val)" />
              vtpay_bank
          </template>
          <template slot-scope="{ row }">
            <el-checkbox :checked="row['vtpay_bank'] > 0"
              @change="(val) => updateListObjDate(row.merchantId, 'vtpay_bank', val)" />
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </el-card>
</template>

<script>
  import channelApi from '@/api/channel';

  export default {
    name: 'channelList',
    data() {
      return {
        checkAllObj: {
          Mobifone: false,
          QRPRO: false,
          VietnamMobile: false,
          Viettel: false,
          Vinaphone: false,
          bankOnline: false,
          bankQr: false,
          bankTransfer: false,
          cardPc: false,
          momoQr: false,
          payout: false,
          viettelFixQr: false,
          viettelQr: false,
          zaloQr: false,
          momo_bank: false,
          zalo_bank: false,
          vtpay_bank: false,
        },
        listObj: {},
        tableData: [],
        selectDatas: [],
        itemKey: Math.random()
      };
    },
    computed: {
      statusData() {
        return [{
            label: this.$t('status.success2'),
            type: 'success',
            value: 1
          },
          {
            label: this.$t('status.error2'),
            type: 'error',
            value: 0
          }
        ];
      }
    },
    mounted() {
      this.getTableData();
    },
    methods: {
      handleCheckAll(prop, val) {
        this.$nextTick(() => {
          this.tableData.forEach((item) => {
            item[prop] = Number(val);
          });
          this.itemKey = Math.random();
        });
      },
      handleSelectionChange(val) {
        this.selectDatas = val;
        console.log(val);
      },
      updateListObjDate(id, key, value) {
        const curObj = this.tableData.find((item) => item.merchantId === id);
        this.$set(curObj, key, Number(value));
      },
      async getTableData() {
        const {
          data
        } = await channelApi.getMerchantChannelList({});
        if (data && +data.code === 200) {
          this.listObj = data.data;
          this.tableData = Object.keys(data.data).map((key) => {
            return {
              merchantId: key.split(':')[0],
              merchantName:key.split(':')[1],
              ...data.data[key]
            };
          });
        }
      },
      async handleSubmit() {
        const params = {};
        this.selectDatas.forEach((item) => {
          const {
            merchantId,
            merchantName,//这个字段不需要传参，过滤掉
            ...restObj
          } = item;
          params[merchantId] = restObj;
        });

        const {
          data
        } = await channelApi.updateChannelList(params);
        if (data.success) {
          console.log(data);
        } else {
          this.$message.error(data.message);
        }
        // this.tableData = res.data.data;
        this.resetHeadStatus();
        await this.getTableData();
      },
      /* --------------------------------- 数据还原 --------------------------------- */
      resetHeadStatus() {
        this.checkAllObj = {
          Mobifone: false,
          QRPRO: false,
          VietnamMobile: false,
          Viettel: false,
          Vinaphone: false,
          bankOnline: false,
          bankQr: false,
          bankTransfer: false,
          cardPc: false,
          momoQr: false,
          payout: false,
          viettelFixQr: false,
          viettelQr: false,
          zaloQr: false,
          momo_bank: false,
          zalo_bank: false,
          vtpay_bank: false,
        };
      }
    }
  };

</script>

<style lang="scss" scoped>
  /deep/ .el-pagination {
    text-align: right;
  }

  i {
    font-style: normal;
  }

</style>



// WEBPACK FOOTER //
// src/components/channelList/index.vue